/* eslint-disable import/no-cycle */
import { achievementsSagas } from '@/features/achievements';
import { activitySagas } from '@/features/activity';
import { forgotPasswordSagas, signInSagas } from '@/features/auth';
import { bridgeSagas } from '@/features/bridge';
import { onboardingSagas } from '@/features/onboarding';
import { progressSagas } from '@/features/progress';
import { stickersOnboardingSagas } from '@/features/stickers-onboarding';
import { wrappedSagas } from '@/features/wrapped';
import autonomySagas from '@/pages/autonomy/Sagas';
import dailyGoalSaga from '@/pages/dailyGoal/Sagas';
import freePlaySagas from '@/pages/freePlay/Sagas';
import goalSettingsSaga from '@/pages/goalSettings/Sagas';
import learningPathSaga from '@/pages/learningPath/Sagas';
import reportSaga from '@/pages/report/Sagas';
import playlistSagas from '@/playlist/Sagas';
import sharedSagas from '@/shared/Sagas';

import dailyReportSaga from '@/components/dailyReport/Sagas';
import addImageSaga from '@/components/modals/addImage/Sagas';
import parentPasswordModalSagas from '@/components/modals/parentPasswordModal/Sagas';
import notificationsSagas from '@/components/notifications/Sagas';
import playButtonSagas from '@/components/playButton/Sagas';

const rootSaga = () => {
	return [
		addImageSaga,
		playlistSagas,
		forgotPasswordSagas,
		notificationsSagas,
		playButtonSagas,
		sharedSagas,
		signInSagas,
		onboardingSagas,
		reportSaga,
		goalSettingsSaga,
		learningPathSaga,
		dailyGoalSaga,
		stickersOnboardingSagas,
		dailyReportSaga,
		activitySagas,
		progressSagas,
		autonomySagas,
		freePlaySagas,
		parentPasswordModalSagas,
		achievementsSagas,
		wrappedSagas,
		bridgeSagas,
	];
};

export default rootSaga;
